"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = require("vue");
var vue_2 = require("vue");
var _withScopeId = function (n) { return (vue_2.pushScopeId("data-v-e7db2852"), n = n(), vue_2.popScopeId(), n); };
var _hoisted_1 = /*#__PURE__*/ vue_2.createStaticVNode("<div class=\"top-container\" data-v-e7db2852><h1 class=\"heading\" data-v-e7db2852>Корзина</h1><div class=\"top-container__right\" data-v-e7db2852><div class=\"top-filter scrollbar\" data-v-e7db2852><div class=\"list\" data-v-e7db2852></div></div></div></div>", 1);
var _hoisted_2 = { class: "row" };
var _hoisted_3 = { class: "col col--main" };
var _hoisted_4 = { class: "col col--aside" };
var vue_3 = require("vue");
var vuex_1 = require("vuex");
var helpers_1 = require("vue_components/helpers");
var OrderSummary_vue_1 = require("vue_components/OrderSummary.vue");
exports.default = vue_1.defineComponent({
    props: {
        orderEditable: { type: Boolean }
    },
    setup: function (__props) {
        var props = __props;
        var store = vuex_1.useStore();
        var orderSummaryItems = vue_3.ref([
            { title: 'Товаров', value: vue_3.computed(function () { return store.state.positions.length; }) },
            { title: 'Сумма с НДС', value: vue_3.computed(function () { return helpers_1.priceStringFormat(store.state.total_cost + store.state.total_discount); }) },
            { title: 'Скидка', value: vue_3.computed(function () { return helpers_1.priceStringFormat(store.state.total_discount); }) },
            { title: 'Доставка', value: vue_3.computed(function () { return helpers_1.priceStringFormat(store.state.delivery_price); }) },
            { title: '??? Скидка по купону ???', value: 0 },
        ]);
        var orderSummarySummary = vue_3.computed(function () { return helpers_1.priceStringFormat(store.state.total_cost); });
        return function (_ctx, _cache) {
            return (vue_2.openBlock(), vue_2.createElementBlock(vue_2.Fragment, null, [
                _hoisted_1,
                vue_2.createElementVNode("div", _hoisted_2, [
                    vue_2.createElementVNode("div", _hoisted_3, [
                        vue_2.renderSlot(_ctx.$slots, "default")
                    ]),
                    vue_2.createElementVNode("div", _hoisted_4, [
                        vue_2.createVNode(OrderSummary_vue_1.default, {
                            editable: props.orderEditable,
                            items: orderSummaryItems.value,
                            summary: vue_2.unref(orderSummarySummary),
                            onClear: _cache[0] || (_cache[0] = function ($event) { return (vue_2.unref(store).dispatch('clearCart')); })
                        }, null, 8, ["editable", "items", "summary"])
                    ])
                ])
            ], 64));
        };
    }
});
